import * as React from 'react';
import { Component } from 'react';
import { IBreadcrumbItem } from '../models/IBreadcrumbItem';
import { Redirect } from 'react-router';
import './Breadcrumbs.css';


interface IProps {
    BreadcrumbItems: IBreadcrumbItem[]
}

interface IState {
    DoRedirect: boolean,
    RedirectPath?: string
}

export class BreadcrumbsComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            DoRedirect: false
        }
    }

    public render() {
        let firstItem: null | JSX.Element = null;
        let nextItems: JSX.Element[] = [];
        if (this.props.BreadcrumbItems.length > 0) {
            firstItem = (
                <span key={0}>
                    <a onClick={this.OnBreadcrumbClick.bind(this, this.props.BreadcrumbItems[0].Path)}>
                        {this.props.BreadcrumbItems[0].ViewName}
                    </a>
                </span>
            );
            if (this.props.BreadcrumbItems.length > 1) {
                for (let i = 1; i < this.props.BreadcrumbItems.length; i++) {
                    nextItems.push((
                        <span key={i}>
                            &nbsp;&nbsp;/&nbsp;&nbsp;
                            <a onClick={this.OnBreadcrumbClick.bind(this, this.props.BreadcrumbItems[i].Path)}>
                                {this.props.BreadcrumbItems[i].ViewName}
                            </a>
                        </span>
                    ));
                }
            }
        }
        return (
            <div className="breadcrumbs-component">
                {this.RenderRedirect()}
                {firstItem}{nextItems}
            </div>
        );
    }

    private OnBreadcrumbClick(path: string, evt) {
        this.setState({
            DoRedirect: true,
            RedirectPath: path
        });
    }

    private RenderRedirect() {
        if (this.state.DoRedirect && this.state.RedirectPath !== undefined) {
            return (
                <Redirect to={this.state.RedirectPath} push={true} />
            );
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/controls/Breadcrumbs.tsx